import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { EndpointTypes } from 'src/models/Channels/endpointType';
import generateId from 'src/lib/generateId';

const useOnSaveRecipientIds = () => {
  const dispatch = useDispatch();
  return useCallback(
    ({ add, validate, workingStateRef, resetErrors, isNew, update }) => {
      const currentWorkingState = workingStateRef.current;
      dispatch(resetErrors());
      if (validate && !dispatch(validate(currentWorkingState))) {
        return;
      }
      const params = { customChannelId: currentWorkingState.configuration.customChannelId, id: currentWorkingState.id };
      const persistFn = isNew ? add : update;
      const data = {
        ...currentWorkingState,
        type: EndpointTypes.CUSTOM_CHANNEL,
        address: `${currentWorkingState.configuration.recipientAddress}:${currentWorkingState.configuration.customChannelId}`,
        ...(isNew ? { id: generateId() } : {}),
      };

      dispatch(persistFn(params, data));
    },
    [dispatch]
  );
};

export default useOnSaveRecipientIds;
